export const produktPreisJahr = 1248;
export const produktPreisMonat = produktPreisJahr / 12; // 104
